import * as React from "react";
import styled from "styled-components";
import {MathUtils} from "../../../utils/math/MathUtils";
import type {INotificationParamsV5, INotificationProps} from "./NotificationV5";
import {NotificationV5} from "./NotificationV5";

interface IAppNotificationsProps {}

interface INotificationElementParams extends INotificationProps {
	guid: string;
	onClose: () => void;
	onProgress: (percent: number) => void;
}

interface IAppNotificationsState {
	activeNotifications: INotificationElementParams[];
}

export class AppNotificationsV5 extends React.PureComponent<IAppNotificationsProps, IAppNotificationsState> {
	constructor(props: IAppNotificationsProps) {
		super(props);
		this.state = {
			activeNotifications: [],
		};
	}

	public notify(params: INotificationParamsV5) {
		const guid = MathUtils.getNewRandomGUID();
		const extendedParams: INotificationElementParams = {
			...params,
			guid: guid,
			onClose: () => {
				this.setState((prevState: IAppNotificationsState) => ({
					activeNotifications: [...prevState.activeNotifications].filter((el) => el.guid !== guid),
				}));
			},
			onProgress: (percentage: number) => {
				this.setState((prevState: IAppNotificationsState) => ({
					activeNotifications: prevState.activeNotifications.map((el) =>
						el.guid === guid ? {...el, progress: percentage, description: `${percentage}%`} : el,
					),
				}));
			},
		};

		this.setState((prevState: IAppNotificationsState) => ({
			activeNotifications: [...prevState.activeNotifications, extendedParams],
		}));

		return extendedParams;
	}

	private getNotifications() {
		return this.state.activeNotifications.map((notificationParams: INotificationElementParams) => (
			<NotificationV5
				key={notificationParams.guid}
				{...notificationParams}
			/>
		));
	}

	public override render() {
		return <AppNotificationsV5Styled>{this.getNotifications()}</AppNotificationsV5Styled>;
	}
}

const AppNotificationsV5Styled = styled.div`
	position: absolute;
	width: 100%;
	top: 0;
	left: 0;
	margin-top: 20px;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	cursor: initial;
	flex-direction: column;
`;
